// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';
// styles
import styles from './index.module.scss';
// Components
import { NavHeader } from './../../../components/navHeader/index';
import { Message } from './../../../components/message/index';
// reducer
import {
  studentAppointmentStatesInitialState,
  studentAppointmentStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from '../../../store/ui-slice';
// services
/***************************************************************************/
/* Name : StudentAppointment React StudentAppointment */
/***************************************************************************/
const StudentAppointment = React.memo(() => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // reducer
  const [studentAppointmentStates, dispatchStudentAppointmentStates] =
    useReducer(
      studentAppointmentStatesReducer,
      studentAppointmentStatesInitialState
    );

  // states
  const studentData = useSelector((state) => state.ui.studentData);
  const [appointed, setAppointed] = useState(
    useSelector((state) => state.ui.studentObj.appointed)
  );
  const [appointDay, setAppointDay] = useState(
    useSelector((state) => state.ui.studentObj.appointedDay)
  );
  const [appointmentHour, setAppointmentHour] = useState(
    useSelector((state) => state.ui.studentObj.appointedHour)
  );

  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // check if studentData is empty
      if (studentData.length === 0) {
        navigate('/');
      }
    })();
  }, []);
  /******************************************************************/
  /* handleCloseSnackbar */
  /******************************************************************/
  const handleCloseSnackbar = () => {
    dispatchStudentAppointmentStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* functions */
  /******************************************************************/
  return (
    <Fragment>
      {<NavHeader title={'موعد  الاختبار الشخصي'} mode={'title'} />}
      <div className={styles['appoint-container']}>
        {!appointed && (
          <Message
            text={
              'لم يتم تحديد موعد لك حتى الان , الرجاء متابعة الموقع باستمرار'
            }
            type={'info'}
          />
        )}
        {appointed && (
          <Message
            text={`تم تحديد موعد لك يوم ${new Date(
              appointDay
            ).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
            })}  ${
              appointmentHour == '9:00' ? 'الفترة الصباحية' : 'الفترة المسائية'
            }
            بداية من الساعة ${appointmentHour}`}
            type={'info'}
          />
        )}
      </div>
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={studentAppointmentStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{studentAppointmentStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={studentAppointmentStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{studentAppointmentStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StudentAppointment };
